import { Global } from '@mantine/core';

export default function GlobalStyles() {
  return (
    <Global
      styles={{
        a: {
          textDecoration: 'none',
        },
        width: '100%',
        height: '100%',
        minHeight: '100vh',
      }}
    />
  );
}
